export default __webpack_public_path__ + "static/media/Coworking_spaces.456e9333.jpg";